import { IconButton, Typography } from '@material-ui/core'
import FilterList from '@material-ui/icons/FilterList'
import LibraryAddOutlined from '@material-ui/icons/LibraryAddOutlined'
import { useState } from 'react'
import { Link } from 'react-router-dom'

import Button from '@/components/button'
import { routes } from '@/routes/config'

import { CalendarHeader } from './components/calendar-header'
import { DiagnosisActivitiesList } from './components/diagnosis-activities-list'
import FilterPanel from './components/filter-panel'
import { FilterOptions, Filters } from './components/filter-panel'
import { StatusHelperModal } from './components/status-helper-modal'
import { ActivitiesCalendarProvider } from './contexts/activities-calendar-context'
import { useStyles } from './styles'

function ActivitiesComponent() {
  const classes = useStyles()

  const [isShowFilters, setIsShowFilter] = useState(false)

  const handleFilterClick = () => {
    setIsShowFilter(!isShowFilters)
  }

  const initialFilters: Filters = {
    order: 'Data de cadastro (Mais antigo)',
    solution: 'Daninhas',
    culture: 'Todas as culturas',
    project: 'Todos os projetos',
    status: 'Todos os status',
  }
  const options: FilterOptions = {
    order: ['Data de cadastro (Mais antigo)'],
    solution: ['Daninhas'],
    culture: ['Todas as culturas'],
    project: ['Todos os projetos'],
    status: ['Todos os status'],
  }
  const [filters, setFilters] = useState<Filters>(initialFilters)

  const handleFilterChange = (newFilters: Filters) => {
    setFilters(newFilters)
  }

  return (
    <div className={classes.container}>
      <div>
        <div className={classes.titleContainer}>
          <Typography variant={'h1'}>Atividades</Typography>
          <IconButton
            color='inherit'
            aria-label='Filtro'
            onClick={handleFilterClick}
          >
            <FilterList color='inherit' />
          </IconButton>
        </div>

        <div className={classes.calendarHeaderContainer}>
          {isShowFilters ? (
            <FilterPanel
              filters={filters}
              filterOptions={options}
              onFilterChange={handleFilterChange}
            />
          ) : null}
          <CalendarHeader />
        </div>
      </div>

      <div className={classes.calendarActivitiesContainer}>
        <DiagnosisActivitiesList />
      </div>

      <div className={classes.newActivityContainer}>
        <StatusHelperModal />
        <Button
          className={classes.newActivityButton}
          component={Link}
          to={routes.ActivityAdd()}
          role='link'
        >
          <LibraryAddOutlined fontSize='small' />
          Agendar nova atividade
        </Button>
      </div>
    </div>
  )
}

export const Activities = () => {
  return (
    <ActivitiesCalendarProvider>
      <ActivitiesComponent />
    </ActivitiesCalendarProvider>
  )
}
